import React from 'react';

import {NewSearchWidgetProps} from "../models/new-search-widget.props";
import {NewSearchWidgetController} from "../new-search-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import classNames from "classnames";
import styles from "../styles/new-search-widget.module.scss";
import {NewSearchWidgetHeader} from "./new-search-widget.header";
import {NewSearchWidgetContent} from "./new-search-widget.content";
import {NewSearchWidgetTabClickComposer} from "../composers/new-search-widget.tab-click.composer";

export class NewSearchWidgetComponentProps extends NewSearchWidgetProps {}

export const NewSearchWidgetComponent = NewSearchWidgetTabClickComposer(({controller, isSmallView}: NewSearchWidgetComponentProps) => {
  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView})}>
      <NewSearchWidgetHeader controller={controller}/>
      <NewSearchWidgetContent controller={controller}/>
    </div>
  )
});

const settings: ComposeSettings = {
  component: NewSearchWidgetComponent,
  propsType: NewSearchWidgetComponentProps,
  controllerType: NewSearchWidgetController,

  shouldTriggerOnRenderComplete: true,
  createModule: true,

  observe: true,
};

export default Compose(settings);
